export const sampleData = [
  {
    rating: 5,
    review:
      '오늘 저녁에는 다이어트 하려고 닭가슴살 샐러드를 선택했는데 너무 맛잇어서 다이어트 성공할 것 같아요. 샐러드는 닭가슴살, 토마토, 상추를 기본으로 했는데, 이 간단한 조합이 이렇게나 맛잇을 수 있다니!  특히 상추가 갓 딴 것처럼 싱싱하고 아삭아삭한 식감이 입안 가득 퍼지면서, 달달한 느낌이 났어요. 닭가슴살은 부드럽고 촉촉한 식감이어서 닭다리같았고, 샐러드에 더해진 렌치 드레싱은 크리미하면서도 가벼워서 재료들의 맛을 강조해주었고, 샐러드가 무겁게 느껴지지 않도록 해주었습니다. 다시 시켜도 저는 여기를 시키겠어요. 완전 강추!!',
    shopName: '댓글몽 샐러드',
    userName: '몽글몽글',
  },
  {
    rating: 5,
    review:
      '맛있어서 일주일에 한 번씩 시켜먹고 있어요☺️ 배달도 빠르고 요청사항도 잘 들어주셔서 생각날 때마다 주문해요. 이번에도 맛있게 잘 먹었어요 대박 나세요🧡​',
    shopName: '더진한 국밥몽​',
    userName: '라멘덕후',
  },

  {
    rating: 5,
    review:
      '집에 손님 올 때마다 주문하고 있습니다. 매번 맛도 좋고 배달도 빨랐는데 오늘은 유난히 배달이 너무 늦게 왔어요. 그래서인지 음식도 조금 식어온 것 같았습니다. 항상 좋았지만 오늘은 조금 아쉬웠어요​',
    shopName: '마라떡몽이​',
    userName: '페페로니​',
  },
  {
    rating: 4,
    review:
      '커피가 정말 일품입니다. 아로마가 풍부하고, 바리스타의 솜씨가 뛰어나네요. 자주 올 것 같아요!',
    shopName: '아로마카페',
    userName: '카페라떼',
  },
  {
    rating: 2,
    review: '오랜만에 시켰는데 맛이 변했나요? 조금 실망했습니다. ​',
    shopName: '몽몽쌀국수​',
    userName: '단골몽​',
  },

  {
    rating: 5,
    review: '',
    shopName: '',
    userName: '몽이',
  },
];

export const sample2 = [
  {
    rating: 4,
    review: '맛은 있었는데 요청사항을 깜빡하셨나봐요 배달도 늦고…. 다음엔 잘 챙겨주시면 좋겠어요​',
    shopName: '몽이파스타​',
    userName: '냠냠​',
  },
  {
    rating: 3,
    review:
      '분위기는 좋았지만, 음식이 조금 더 매운 편이었어요. 매운 걸 잘 못 먹는 분들은 주의하셔야 할 듯',
    shopName: '매운맛 천국',
    userName: '매운맛초보',
  },
  {
    rating: 5,
    review:
      '한식 불고기가 정말 맛있습니다. 고기가 부드럽고 잘 양념되어 있어요. 한국 음식이 그리울 때 자주 오게 됩니다.',
    shopName: '한식의 정석',
    userName: '한식사랑',
  },
  {
    rating: 5,
    review:
      '한식 불고기가 정말 맛있습니다. 고기가 부드럽고 잘 양념되어 있어요. 한국 음식이 그리울 때 자주 오게 됩니다.',
    shopName: '한식의 정석',
    userName: '한식사랑',
  },
];

export const sample = {
  rating: 3,
  review:
    '쌀국수가 조금 싱거웠어요. 소스를 추가해서 먹으니 괜찮았습니다. 분위기와 서비스는 좋았습니다.',
  shopName: '베트남 쌀국수',
  userName: 'anonymous',
};
